module.exports = "https://coursera_assets.s3.amazonaws.com/images/03053751b77164390e5faa12afb68835.jpg";